// Hauteur du header-main //
function resize_header_height() {
  var scroll_top = $(document).scrollTop() ;
  if(scroll_top >= 200) {
    $('#header').addClass('resized');
    $('body').addClass('header-resized');
  } else {
    $('#header').removeClass('resized');
    $('body').removeClass('header-resized');
  }
}

// Homeslider parallax effect //
function homeslider_parallax() {
  if($(document).width() > 900){
    var scroll_top = $(document).scrollTop() ;
    var intro_top = (scroll_top/4) ;
    $('#homeslider .bx-wrapper').css({
      '-webkit-transform':'translateY('+intro_top+'px)',
      '-moz-transform':'translateY('+intro_top+'px)',
      'transform':'translateY('+intro_top+'px)'
    });
  }
}

//Gestion de l'ouverture et de la redirection des langues
function gestion_langues() {
  if($(".lang-selector-form").length) {
   $(".lang-selector-form").each(function() {

     $(this).find("span.current-lang").click(function() {
      $(this).parent().toggleClass("active");
    });

     $(this).find("a.change-lang").click(function(e) {
      e.preventDefault();

      $(this).parent().find("input[name='lang']").val($(this).attr("data-lang"));

      $(this).parent().submit();
    });
   });
 }
}

// Navigation mobile //
function header_nav_mobile() {
  $('#toggle-nav-mobile,#nav-mobile-close').on('click',function(){
    $('#nav-mobile,#toggle-nav-mobile').toggleClass('active');
  });
}

// Adaptation hauteur des éléments "Actualités" / Push" //
function hauteurEgale(group) {
  tallest = 0;
  group.each(function() {
    thisHeight = $(this).outerHeight(true);
    if(thisHeight > tallest) {
      tallest = thisHeight;
    }
  });
  group.css('height',tallest+'px');
}

// Ouverture d'une actualité //
function open_news(news,link) {
  news.children('h3').on('click',function(){             window.location.href = link ;})
  news.children('span').on('click',function(){           window.location.href = link ;})
  news.children('p').on('click',function(){              window.location.href = link ;})
  news.children('.news-arrow').on('click',function(){    window.location.href = link ;})
}

// Fixation du footer si window > body //
function fixedFooter(_class){
  if($("body").height()<$(window).height()){
    $(_class).css({
      "position": "fixed",
      "bottom": "0",
      "width": "100%"
    });
  }
}

// Fonction permettant de centrer horizontalement une image qui est plus ...
// ... large que son conteneur (idem "center center" pour un background-image)
function center_image_too_large(image,conteneur){
  // on récupère la largeur du conteneur
  var conteneur_width = conteneur ? $(conteneur).width() : $(image).parent().width() ;
  $(image).each(function(){
    var image_largeur = $(image).width();
    var image_new_margin = 0;
    var image_new_margin = image_largeur - conteneur_width;
    if(image_new_margin > 0) {
      image_new_margin = image_new_margin / 2;
      $(image).css({'margin-left':'-'+image_new_margin+'px','margin-right':'-'+image_new_margin+'px'}); }
      else {
        $(image).css({'margin-left':'0px','margin-right':'0px'});
      }
    })
}

$(window).on('load',function(){ center_image_too_large('.homeslider-img','#homeslider'); });
$(window).on('resize',function(){ center_image_too_large('.homeslider-img','#homeslider'); });
// $(window).on('load',function(){ center_image_too_large('#chapeau-image img','#chapeau-image'); });
// $(window).on('resize',function(){ center_image_too_large('#chapeau-image img','#chapeau-image'); });

// Adaptation de la taille de la flèche sous le chapeau //
function animation_fleche_chapeau(cible){
  if($(cible).length){
    // adaptation de la largeur en fonction de la fenêtre
    var window_width = $(window).width();
    var fleche_border_width = window_width / 2;
    $('#animarrow').empty();
    $('#animarrow').prepend('<style>'+cible+':before{border-width:100px '+fleche_border_width+'px 0 !important;}</style>');
  }
}

// Animation de la flèche sous la bannière de la homepage //
function animation_fleche_chapeau_homepage(cible) {
  var window_width = $(window).width();
  var fleche_border_width = window_width / 2;
  var scroll_top = $(document).scrollTop() ;
  var window_height = $(window).height();
  // elements de comparaison
  var scrolltop_chapeau = $(cible).offset();
  var hauteur_chapeau = $(cible).outerHeight();
  hauteur_fleche = scrolltop_chapeau.top + hauteur_chapeau;
  // animation au scroll : l'animation commence lorsque la flèche passe la moitié de la hauteur de la fenêtre
  if(scroll_top > (hauteur_fleche / 2)) {
    var delta = scroll_top / 5 ;
    delta = 212 - delta;
    $('#animarrow').prepend('<style>'+cible+':before{border-width:100px '+fleche_border_width+'px 0;top:'+hauteur_chapeau+'px;bottom:auto;}</style>');
  }
}

// Parallax de l'image de la rangée chapeau //
function chapeau_parallax(){
  //if($(document).width() > 900){
    var scroll_top = $(document).scrollTop() ;
    var image_top = (scroll_top/4) ;
    var chapeau_margin = 0;
    if(scroll_top > 0) {
      chapeau_margin = 0 + (scroll_top/2) ;
    } else {
      chapeau_margin = 0;
    }
    if($(document).width() > 740 && !$("body").hasClass('mobile')){
      $('#chapeau').css({'top': '-'+chapeau_margin+'px'},0);
      $('#chapeau-image').css({'bottom':'-'+(chapeau_margin+350)+'px'},0);
    }else{
      $('#chapeau').css({'top':'200px'},0);
      $('#chapeau-image').css({'bottom':'-200px'},0);
    }
  //}
}

// Gestion des popup du tableau des conseils //
function construct_popup_conseils(cible) {
  cible.on('click',function(){
    if(cible.hasClass('active')) {
      // nothing
    } else {
      var modulated = $('.modulated');
      if(modulated.hasClass('active')){
        modulated.children('.tableau-popup-modulated').remove();
        modulated.removeClass('active');
      }
      // on ferme toutes les popup
      $('.icon-cont-hover').removeClass('active');
      $('.tableau-popup').remove();
      // on ouvre la popup active
      var description = cible.parent().attr('data-description');
      cible.addClass('active');
      cible.children('.icon-cont').after('<div class="tableau-popup"><div class="tableau-popup-content"><div class="tableau-popup-close"><div class="tableau-popup-close-icon"></div></div>'+description+'</div></div>');
      // on charge l'action de fermeture
      close_popup_conseils(cible);
    }
  });
}
function close_popup_conseils(cible){
  var btn_close = cible.children('.tableau-popup').children('.tableau-popup-content').children('.tableau-popup-close');
  btn_close.on('click',function(){
    cible.children('.tableau-popup').remove();
    cible.removeClass('active');
    return false;
  });
}

function construct_popup_conseils_modulated(cible){
  cible.on('click', function(){
    if(cible.hasClass('active')) {
        // nothing
      } else {
        var notModulated = $('.icon-cont-hover');
        if(notModulated.hasClass('active')){
          notModulated.children('.tableau-popup').remove();
          notModulated.removeClass('active');
        }
        // on ferme toutes les popup
        $('.modulated').removeClass('active');
        $('.tableau-popup-modulated').remove();
        // on ouvre la popup active
        var description = cible.parent().attr('data-module-description');
        cible.addClass('active');
        cible.children('.module-btn').after('<div class="tableau-popup-modulated"><div class="tableau-popup-content"><div class="tableau-popup-close"><div class="tableau-popup-close-icon"></div></div>'+description+'</div></div>');
        // on charge l'action de fermeture
        close_popup_conseils_modulated(cible);
      }
    });
}

function close_popup_conseils_modulated(cible){
  var btn_close = $('.tableau-popup-modulated').children('.tableau-popup-content').children('.tableau-popup-close');
  btn_close.on('click',function(){
    $('.tableau-popup-modulated').remove();
    cible.removeClass('active');
    return false;
  });
}

// ----- //
$(window).load(function(){
  if (window.innerWidth > 768) {
    //hauteurEgale($('.news-inner'));
    // Par ligne (groupe de 3) pour la page "Actualités"
    //console.log("Same heiught on news", $('#all-news .news-inner').length);
    var total_news_lines = parseInt($('#all-news .news-inner').length / 3);
    //console.log($('#all-news .news-inner').length, "total lines : ",total_news_lines);
    for (i = 0; i < total_news_lines; i++) {
      hauteurEgale($('.news-inner:eq('+i*3+'), .news-inner:eq('+(i*3 + 1)+'), .news-inner:eq('+(i*3 + 2)+')'));
    }
    // Trois dernières Actualités
    hauteurEgale($('#last-news .news-inner'));

    hauteurEgale($('.banner-push-box'));
    hauteurEgale($('.news-categories'));
    hauteurEgale($('.chapeau-bloc a'));
  };
});

// ----- //
$(document).ready(function(){

  // Adaptation de la flèche en bas des chapeaux
  animation_fleche_chapeau('#chapeau');
  $(window).on('resize',function(){
    animation_fleche_chapeau('#chapeau');
  });
  $(window).on('scroll',function(){
    animation_fleche_chapeau('#chapeau');
  });

  if($('body#home').length){
    // Adaptation flèche de la bannière "push" spécifique de la homepage //
    animation_fleche_chapeau('#banner-push');
    $(window).on('resize',function(){
      animation_fleche_chapeau('#banner-push');
    });
    $(window).on('scroll',function(){
      animation_fleche_chapeau('#banner-push');
    });
    // Animation de la flèche sour la bannière de la homepage //
    animation_fleche_chapeau_homepage('#banner-push');
    $(window).on('resize',function(){
      animation_fleche_chapeau_homepage('#banner-push');
    });
    $(window).on('scroll',function(){
      animation_fleche_chapeau_homepage('#banner-push');
    });
    // Homeslider seulement sur la page "home" en mode atm-public //
    if(!$('body.atm-edit').length) {
      $(window).on('scroll',homeslider_parallax);
      $(window).on('resize',homeslider_parallax);
    }
    // ===== //
  }

  // Parallax de l'image de la rangée chapeau
  if($('#chapeau-image img').length){
    chapeau_parallax();
    $(window).on('scroll',chapeau_parallax);
    $(window).on('resize',chapeau_parallax);
  }

  // Génération des descriptions du tableau des conseils //
  if($('body#offer-advices').length) {
    $('.icon-cont-hover').each(function(){
      construct_popup_conseils($(this));
    });
    $('.modulated').each(function(){
      construct_popup_conseils_modulated($(this));
    });
  }

  // On replace la <div class="replace-by-h2"> du chapeau par l'attribut <h2>
  if($('.replace-by-h2').length){
    var _this = $('.replace-by-h2');
    var contenu = _this.text();
    _this.after('<h2>'+contenu+'</h2>');
    _this.remove();
  }


  // Lien vers ancre sous le chapeau //
  $('#btn-scroll-bot').on('click',function() {
    var speed = 750;
    var hauteur_to_scroll = $("#btn-scroll-cible").offset().top - $('#header').height() + 37 ;
    $('html, body').animate( { scrollTop: hauteur_to_scroll }, speed ); // Go
    return false;
  });

  // Slider des clients
  $("#slidistributeurs ul").bxSlider({
    auto: true,
    autoHover: true,
    speed: 1000,
    pause: 3000,
    minSlides: 3,
    maxSlides: 4,
    moveSlides: 1,
    slideWidth: 170,
    slideMargin: 60,
    pager: false,
    prevSelector: '#slidistributeur-prev',
    nextSelector: '#slidistributeur-next',
    nextText: '',
    prevText: ''
  });

  // Slider des chiffres clés
  $('#chiffreslider ul').bxSlider({
    mode: 'fade',
    auto: true,
    minSlides: 1,
    maxSlides: 1,
    slideWidth: 500,
    slideMargin: 0,
    pager: false,
    prevSelector: '#chiffres-prev',
    nextSelector: '#chiffres-next',
    nextText: '',
    prevText: ''
  });

  // Effet au scroll du header //
  resize_header_height();
  $(window).on('scroll',resize_header_height) ;

  // Activation du boutons "choix de langue" //
  gestion_langues();

  // Navigation mobile //
  header_nav_mobile();

  // Fixation du footer //
  /*
  fixedFooter("#footer");
  $(window).on('resize',fixedFooter);
  */

  // Fenêtres modales magnific popup //
  //$('.img-zoom').magnificPopup({
    $('#news-detail-image, .media-news-details').magnificPopup({
      type: 'image',
      mainClass: 'mfp-zoom-animated',
      zoom: {
        enabled: true,
        duration: 300,
        easing: 'ease-in-out',
        opener: function(openerElement) {
          return openerElement.is('img') ? openerElement : openerElement.find('img');
        }
      }
    });

  // Ouverture d'une actualité (multiples liens sur une actu) //
  $('.news-inner').each(function(){
    var _news = $(this);
    var _newsLink = _news.attr('data-news-href');
    open_news(_news,_newsLink);
  });

  // Bouton scroll bottom des pages internes //
  $('#btn-scroll-bot.scroll-news').on('click',function(){
    var speed = 750;
    var hauteur_to_scroll = $("#news-main").offset().top - $('#header').height() + 37 ;
    $('html, body').animate({scrollTop:hauteur_to_scroll},speed );
    return false;
  });

});
